import type {
  ActionHandlers,
  ImportExportHistoryTableProps,
} from '@/components/ImportExportHistory/Table';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

/**
 * Hook for ImportExportHistory table data and action handlers.
 * TODO: Replace with actual API.
 */
export const useImportExportHistoryTable = () => {
  const { t } = useTranslation();

  const table = useMemo<ImportExportHistoryTableProps>(
    () => ({
      data: [],
      emptyText: t('import_export_history_list_empty_message'),
    }),
    [t]
  );

  // TODO: Implement when API is available
  const actionHandlers = useMemo<ActionHandlers>(
    () => ({
      onDownloadClick: async () => {},
      onCancelClick: async () => {},
      onDetailsClick: undefined,
    }),
    []
  );

  return { table, actionHandlers };
};
